import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  connectFirestoreEmulator,
  enableMultiTabIndexedDbPersistence
} from 'firebase/firestore'
import {
  getAuth,
  connectAuthEmulator
  // signInWithCredential,
  // EmailAuthProvider
} from 'firebase/auth'

// Firebase configuration for ses-test-server project
const firebaseConfig = {
  apiKey: "AIzaSyDsv0xjYi-eVdBAjn0wkcpOXbbDDiu1cNc",
  authDomain: "ses-test-server.firebaseapp.com",
  projectId: "ses-test-server",
  storageBucket: "ses-test-server.firebasestorage.app",
  messagingSenderId: "882460515585",
  appId: "1:882460515585:web:5ee9d55e91e09cf0cc4f00",
  measurementId: "G-TERPYB7HLY"
}

const initFirebase = async () => {
  try {
    const app = initializeApp(firebaseConfig)
    const firestore = getFirestore(app)
    const auth = getAuth(app)

    if (process.env.NODE_ENV !== 'production') {
      // connectAuthEmulator(auth, 'http://localhost:9099')
      // connectFirestoreEmulator(firestore, 'localhost', 8080)
      try {
        await enableMultiTabIndexedDbPersistence(firestore)
      } catch (err) {
        console.warn('Firestore persistence failed:', err)
      }
      /**
       * The following code logins the user automatically to speed up development.
       * For this to work you first need to create a user and then run the command
       * yarn emulator:export, then import the data when starting the emulator
       * yarn firebase emulators:start --only firestore,auth --import=firestore_mock_data
       */
      // signInWithCredential(
      //   auth,
      //   EmailAuthProvider.credential('john@doe.com', '123123')
      // )
    }
  } catch (err) {
    console.error(err)
    return err
  }
}

export default initFirebase
